$(document).ready(function(){
    if (jQuery('.sortable-table').length){
        jQuery('.sortable-table').dataTable({
            "searching": false,
            "info": false,
            "paging": false
        });
    }
});

$.fn.dataTableExt.sErrMode = 'throw';